export default __webpack_public_path__ + "static/flyer3-eade5cb998fa28020cf8aee4e516d16e.jpg";